<template>
    <div>
        <el-row type="flex">
            <el-col>
                <el-menu
                    :router="true"
                    :default-active="$route.path"
                    class="side-menu-vertical-top"
                    :collapse="isCollapse"
                    background-color="black"
                    text-color="#fff"
                    active-text-color="teal"
                >
                    <el-menu-item @click="handleCollapse">
                        <div v-if="isCollapse" class="text-center">
                            <i class="fas fa-bars"></i>
                        </div>
                        <div v-else>
                            <span slot="title" style="font-size:1.3125em;">
                                fillgoods
                            </span>
                            <div class="float-right">
                                <i class="fas fa-bars" style="color:#fff;"></i>
                            </div>
                        </div>
                    </el-menu-item>
                    <SubMenu
                        v-for="item in menuNavbar"
                        :item="item"
                        :key="item.permission_id"
                        @handleCollapseMenu="collapseMenu"
                    />
                </el-menu>
                <el-menu
                    class="side-menu-vertical-bottom"
                    :collapse="isCollapse"
                    background-color="black"
                    text-color="#fff"
                    default-active="0"
                >
                    <el-row>
                        <el-col>
                            <el-menu-item index="1">
                                <el-avatar
                                    :src="require('@/assets/image-profile.png')"
                                    size="small"
                                ></el-avatar>
                                <span slot="title"
                                    >&nbsp;{{
                                        firebase.auth().currentUser &&
                                            firebase.auth().currentUser.email
                                    }}</span
                                >
                            </el-menu-item>
                            <el-menu-item
                                @click.native="logoutClient"
                                index="2"
                            >
                                <i class="el-icon-unlock"></i>
                                <span slot="title">Logout</span>
                            </el-menu-item>
                        </el-col>
                    </el-row>
                </el-menu>
            </el-col>
        </el-row>
        <div class="env-show">{{ mode }} mode</div>
    </div>
</template>

<script>
import firebase from 'firebase/app'
import fgApi from '@/services/fillgoods'
import { NavigationMenu } from './NavigationContent.js'
import { get } from 'vuex-pathify'
import SubMenu from '@/components/navMenu/SubMenu.vue'
import { mapState } from 'vuex'
import difference from 'lodash/difference'
import { vueAppSelMode } from '@/config'

const sidebarWidthVal = '64px'

export default {
    components: { SubMenu },
    props: {
        sidebarDetail: {
            type: Object,
            default: () => {
                return {
                    sidebarWidth: sidebarWidthVal
                }
            }
        }
    },
    data () {
        return {
            visible: false,
            activeIndex: '1',
            courierProviders: [],
            mode: vueAppSelMode,
            isCollapse: true,
            menu: NavigationMenu,
            firebase
        }
    },
    watch: {
        isCollapse (val) {
            this.sidebarDetail.sidebarWidth = val ? sidebarWidthVal : '250px'
        }
    },
    computed: {
        permission: get('permission'),
        ...mapState({
            user: state => state.user.objUser
        }),
        menuNavbar () {
            let defaultMenu = []

            // console.log('this.permissionthis.permission', this.permission)
            if (this.permission.isOutSourceMobileOrder) {
                const parentMenu = this.menu.find(
                    item => item.label === 'Order'
                )
                const subMenu = parentMenu.subMenu.find(
                    item => item.routerPath === '/oms/logOrder/mobileOrder'
                )
                parentMenu.subMenu = [subMenu]

                defaultMenu.push(parentMenu)

                // newMenu['Order'] = this.menu.Order
                // let orderMobile = this.menu.LogOrder.subMenu[5]
                // newMenu.LogOrder.subMenu = [orderMobile]
                // defaultMenu = newMenu

                // } else if (this.permission.isDevCaseTracking) {
                //     let newMenu = {}
                //     newMenu['Case'] = this.menu.Case
                //     defaultMenu = newMenu
            } else {
                const arrMenu = this.menu.filter(menu => {
                    let result = true
                    // console.log(menu)
                    if (menu.subMenu) {
                        result = menu.subMenu.length !== 0
                    }
                    return result
                })
                if (arrMenu) {
                    defaultMenu = arrMenu
                } else {
                    defaultMenu = this.menu
                }
            }
            return defaultMenu
        }
    },
    async created () {
        try {
            let token = await firebase.auth().currentUser.getIdToken()
            if (token) {
                const {
                    success,
                    data,
                    errors
                } = await fgApi.permission.getMenu({
                    email: this.user.email
                })
                if (success) {
                    this.handleMenu(data.permissionIds)
                } else if (
                    errors[0].status === 'NOTFOUND' &&
                    !this.permission.isOutSourceMobileOrder &&
                    !this.permission.isDevCaseTracking
                ) {
                    const defaultMenu = this.menu.find(
                        item => item.permission_id === 0
                    )
                    if (defaultMenu) this.menu = []
                    this.menu.push(defaultMenu)
                } else {
                    throw new Error(errors[0].message)
                }
            }
        } catch (err) {
            console.log('menu is broken', err)
        }
    },
    methods: {
        handleMenu (id) {
            let arrDifferenceId = []
            this.menu.forEach(async (el, i) => {
                if (el.subMenu) {
                    const arrId = await el.subMenu.map(
                        item => item.permission_id
                    )
                    arrDifferenceId = await difference(arrId, id)
                    if (arrDifferenceId) {
                        let restSubMenu = []
                        await el.subMenu.forEach(subItem => {
                            if (
                                !arrDifferenceId.includes(subItem.permission_id)
                            ) {
                                restSubMenu.push(subItem)
                            }
                        })
                        el.subMenu = restSubMenu
                    }
                }
            })
        },
        handleSelect (index) {
            console.log(index)
            this.activeIndex = this.$route.path
        },
        logoutClient () {
            firebase
                .auth()
                .signOut()
                .then(() => {
                    this.$store.set('user/objUser', null)
                    localStorage.removeItem('selMode')
                    this.$router.push({ path: '/login' })
                })
        },
        setMode (env) {
            console.log(this.$store, env)
            this.$store.set('envSystem/mode', env)
        },
        handleCollapse () {
            // expand and collapse side menu
            this.isCollapse = !this.isCollapse
            this.$emit('onNavbarExpand', this.isCollapse)
        },
        collapseMenu () {
            // colloapse side menu when selected
            this.isCollapse = true
        }
    }
}
</script>

<style lang="scss" scoped>
.el-menu-item.is-active {
    color: white !important;
    font-weight: bold;
}
.el-submenu.is-active {
    div {
        span {
            color: white !important;
            font-weight: bold;
        }
    }
}
.sub-icon {
    text-align: center;
}
::v-deep .el-submenu__title i {
    color: #fff !important;
}
::v-deep .el-submenu__icon-arrow {
    font-size: 18px;
}
::v-deep .el-popover {
    background: #000000 !important;
}
::v-deep .popper__arrow ::after {
    display: none;
}
.el-popover {
    position: absolute;
    background: #000000;
}
.popover.bottom .arrow:after {
    border-bottom-color: tomato;
}
.popover {
    background: tomato;
}

// .type-login{
//     color: teal !important;
//     padding: 5px 5px 5px 5px;
//     font-weight: bold;
// }
.env-show {
    color: red;
    border: 1px solid black;
    background-color: white;
    position: fixed;
    padding-left: 5px;
    padding-right: 5px;
    margin-left: 10px;
    margin-bottom: 5px;
    bottom: 0;
    right: 0;
    z-index: 2002;
}
// .userinfo {
//     // text-align: right;
//     // padding-right: 35px;
//     // float: right;
// }
.side-menu-vertical-top {
    z-index: 2001;
    position: fixed;
    text-align: left;
    height: 85vh;
    overflow-y: auto;
    &:not(.el-menu--collapse) {
        width: 250px;
    }
    .menu-item-layout {
        .el-tooltip {
            text-align: center;
        }
    }
}
.side-menu-vertical-bottom {
    z-index: 2001;
    position: fixed;
    text-align: left;
    height: 15vh;
    bottom: 0;
    &:not(.el-menu--collapse) {
        width: 250px;
    }
}
.fa-icon-pad-left {
    margin-left: 7px !important;
}
</style>
